<ng-container *ngIf="!isLoading">
  <div class="noPrint" style="display: flex; justify-content: flex-end; gap: 1rem; margin-bottom: 1rem;">
    <button
      [printStyle]="{
        table: { 'border-collapse': 'collapse', width: '100%' },
        td: { border: 'solid 1px', 'font-size': '14px', 'text-align': 'center' },
        th: { border: 'solid 1px', 'font-size': '16px', 'font-weight': '600', 'text-align': 'center' }
      }"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button (click)="exportExcel('Prantwise_Subscription_Report')" mat-raised-button color="primary">
      Export
    </button>

    <button mat-dialog-close mat-raised-button color="warn">
      Close
    </button>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <div id="print-section" class="container" *ngIf="!errorMessage">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th colspan="5" class="text-center largeHeading">
            दि {{ endDate | date:"dd/MM/yyyy" }} च्या अंकाकरिता वर्गणीदार सध्यस्थिती
          </th>
        </tr>
        <tr>
          <th style="width:5%">#</th>
          <th style="width:35%">प्रांत</th>
          <th style="width:20%">प्रती</th>
          <th style="width:20%">जमा</th>
          <th style="width:20%">येणे</th>
        </tr>
      </thead>

      <tbody>
        <!-- One row per prant (aggregate totals only) -->
        <tr *ngFor="let item of showPrantData; let i = index">
          <td>{{ i+1 }}</td>
          <td>{{ item['prantName'] }}</td>
          <td>{{ item['prati'] }}</td>
          <td>{{ item['jama'] }}</td>
          <td>{{ item['yene'] }}</td>
        </tr>

        <!-- Other Prant Data -->
        <ng-container *ngIf="showOtherPrantData?.length">
          <tr *ngFor="let item of showOtherPrantData; let i = index">
            <td>{{ showPrantData.length + i + 1 }}</td>
            <td>{{ item['name'] }}</td>
            <td>{{ item['prati'] }}</td>
            <td>{{ item['jama'] }}</td>
            <td>{{ item['yene'] }}</td>
          </tr>
        </ng-container>

        <!-- Final Total -->
        <tr class="fontBold table-dark text-black">
          <td></td>
          <td>एकूण</td>
          <td>{{ totalPratiTotal }}</td>
          <td>{{ totalJamaTotal }}</td>
          <td>{{ totalYeneTotal }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- Loading State -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>